import { gql } from "../__generated__";

export const GetEventById = gql(`
  query GetEventById(
    $where: EreignisWhereUniqueInput!
    $hydrateRelationships: Boolean!
  ) {
    event: ereignis(where: $where) {
      id
      title
      subtitle
      description {
        document(hydrateRelationships: $hydrateRelationships)
      }
      images {
        images {
          bild {
            url
            id
          }
          objekte {
            title
            id
            description {
              document(
                hydrateRelationships: $hydrateRelationships
              )
            }
            copyright {
              name
            }
            images {
              title
              name
            }
            periodOfOrigin {
              displayName
            }
            authorPerson {
              familyName
              givenName
              id
            }
            authorGroup {
              id
              bezeichnung
            }
            personsOnWork {
              familyName
              givenName
              id
            }
            groupsOnWork {
              id
              bezeichnung
            }
            locationOnWork {
              id
              name
            }
          }
        }
      }
      typen {
        name
      }
      periodOfOrigin {
        displayName
      }
      place {
        name
        id
      }
      characters {
        familyName
        givenName
        id
      }
      partOf {
        title
        id
      }
      contains {
        id
        title
      }
      similarTo {
        id
        title
      }
      weblinks {
        document
      }
    }
  }
`);
